(() => {
  'use strict';

  const root = document.querySelector('[data-n2l-auth]');
  if (!root || root.dataset.n2lAuthBound === 'true') return;
  root.dataset.n2lAuthBound = 'true';

  try {
    const params = new URLSearchParams(window.location.search);
    let returnTo = params.get('return_to') || '';
    if (!returnTo.startsWith('/') || returnTo.startsWith('//')) returnTo = '';
    if (String(params.get('next') || '').toLowerCase() === 'orders') {
      returnTo = '/pages/account#n2l-account-orders';
    }

    if (params.get('reopen_cart') === '1') {
      try {
        sessionStorage.setItem('n2l_reopen_cart', '1');
      } catch (err) {
        /* ignore */
      }
    }

    if (returnTo) {
      root.querySelectorAll('a[href^="/customer_authentication/login"]').forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.set('return_to', returnTo);
        link.setAttribute('href', url.pathname + url.search);
      });
    }
  } catch (e) {
    /* ignore */
  }
})();
